import React from "react";

const MultiColorBar = ({
  colors = [
    "#E8550D",
    "#F7A64F",
    "#F2E103",
    "#1BBB6B",
    "#3CADF1",
    "#2660CE",
    "#922590",
    "#C9C9C9",
  ],
  height = "15px",
  labelClassName,
  label,
  border = false,
}) => {
  return (
    <div className="d-flex flex-column gap-2">
      {label && <label className={`${labelClassName}`}>{label}</label>}
      <div className="rounded-pill  d-flex align-items-center ">
        {colors.map((color, key) => (
          <div
            key={key}
            style={{ backgroundColor: color, color: color, height: height }}
            className={`${key === 0 && "rounded-end rounded-pill"} ${
              key === colors.length - 1 && " rounded-start rounded-pill"
            } ${border && "border-start border-white"} w-100`}
          ></div>
        ))}
      </div>
    </div>
  );
};

export default MultiColorBar;
